module.exports = __webpack_public_path__ + "img/ztxxzs.fd2d2c33.png";